import { ClipboardCheck, Inbox, ListChecks, UserCheck, Workflow, Wrench } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

/**
 * Assignment left Human Resources (08-12 audit E2).
 *
 * The finding was exactly this file plus one line in `nav-registry`:
 * `/assignment` was registered in the HR group, so dispatching a work order
 * lived beside Attendance and Roster. Assignment is where operational work goes,
 * so the entries now sit with the work itself — check assignment under Quality
 * beside Checks, maintenance dispatch under Maintenance — and the cross-domain
 * supervisor view keeps its own entry.
 *
 * **`/assignment` itself is deliberately NOT an entry any more.** Its ROUTE
 * survives (a redirect) so bookmarks and deep links never 404, which is the
 * convention `App.tsx` already documents and E2's own acceptance criterion.
 */
export const assignmentNav: NavEntry[] = [
  /** Owner decision 2026-09-18: MY TASKS = what is mine (My assignments) and
   * what I could take (Available work); the cross-team Assignment activity
   * moved out to Metrics. No permission: everybody has a to-do list. */
  { label: 'My assignments', icon: ListChecks, path: '/my-assignments', order: 2 },
  { label: 'Available work', icon: Inbox, path: '/my-work', permission: 'assignment:read', order: 3 },
  { label: 'Check assignment', icon: ClipboardCheck, path: '/checks/assignment', permission: 'assignment:read', order: 6 },
  { label: 'Dispatch', icon: Wrench, path: '/maintenance/dispatch', permission: 'assignment:read', order: 21 },
  { label: 'Assignment activity', icon: UserCheck, path: '/assignment/activity', permission: 'assignment:read', order: 22 },
  { label: 'Automation', icon: Workflow, path: '/automation', permission: 'settings:read', order: 35 },
]
